import { render, staticRenderFns } from "./ClientPersonalInfoForm.vue?vue&type=template&id=66a63462&"
import script from "./ClientPersonalInfoForm.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ClientPersonalInfoForm.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports